<script setup lang="ts">
import { useLocale } from '@/composables/useLocale'
import { ELocale } from '@/types/ELocale'

const { currentLocale, setLocale } = useLocale()

function toggleLanguage() {
  const next = currentLocale.value === ELocale.RU ? ELocale.EN : ELocale.RU
  setLocale(next)
}
</script>

<template>
  <v-btn
    variant="text"
    density="comfortable"
    class="language-switcher text-caption font-weight-bold px-2"
    @click="toggleLanguage"
  >
    <span :class="{ 'active-lang': currentLocale === ELocale.RU }">RU</span>
    <span class="mx-1 opacity-50">/</span>
    <span :class="{ 'active-lang': currentLocale === ELocale.EN }">EN</span>
  </v-btn>
</template>

<style scoped>
.language-switcher {
  border-radius: 8px;
  min-width: auto;
}
.active-lang {
  color: rgb(var(--v-theme-primary));
  font-weight: 700;
}
</style>
